import ManifoldModule from 'manifold-3d';
import wasmUrl from 'manifold-3d/manifold.wasm';
import { createDoorLeafBuilder } from './doorLeafGeometry';
import { createDoorFrameBuilder, geometryOf } from './doorFrameGeometry';
import { resolveWaternose, waternoseSolid } from './waternoseGeometry';
import { mapExtrudedWoodUVs } from './woodUV';

let builderPromise;

export function loadDoorLeafBuilder() {
  if (!builderPromise) {
    builderPromise = ManifoldModule({ locateFile: () => wasmUrl }).then((module) => {
      module.setup();
      const build = createDoorLeafBuilder(module.Manifold);
      build.frame = createDoorFrameBuilder(module.Manifold);
      build.waternose = (config) => {
        const owned = [], keep = s => { owned.push(s); return s; };
        try {
          const spec = resolveWaternose(config.waternose, config.heightMm);
          const geometry = geometryOf(waternoseSolid(module.Manifold, keep, spec, config.widthMm));
          return mapExtrudedWoodUVs(geometry, [spec.profileMm], { lengthAxis: 'x', sectionAxes: ['z','y'], originMm: [0,spec.yMm] });
        }
        finally { owned.reverse().forEach(s => s.delete()); }
      };
      return build;
    }).catch((error) => {
      builderPromise = undefined;
      throw error;
    });
  }
  return builderPromise;
}
